// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    watchlist: [],
    watchlistItem: null,
    standings: [],
    loading: false,
    pagination: {
        total: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 20
    }
};

const slice = createSlice({
    name: 'watchlist',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        // SET LOADING
        setLoading(state, action) {
            state.loading = action.payload;
        },

        // GET watchlist
        getWatchlistSuccess(state, action) {
            state.watchlist = action.payload.data;
            state.pagination = action.payload.pagination;
            state.loading = false;
        },

        // CREATE watchlist item
        createWatchlistSuccess(state, action) {
            state.watchlist.unshift(action.payload);
            state.pagination.total += 1;
            state.loading = false;
        },

        // UPDATE watchlist item
        updateWatchlistSuccess(state, action) {
            const index = state.watchlist.findIndex(item => item.id === action.payload.id);
            if (index !== -1) {
                state.watchlist[index] = action.payload;
            }
            state.loading = false;
        },

        // DELETE watchlist item
        deleteWatchlistSuccess(state, action) {
            state.watchlist = state.watchlist.filter(item => item.id !== action.payload);
            state.pagination.total -= 1;
            state.loading = false;
        },

        // GET standings
        getStandingsSuccess(state, action) {
            state.standings = action.payload;
            state.loading = false;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchWatchlist(page = 1, limit = 20) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            const response = await axios.get(`/api/rooms/watchlist?page=${page}&limit=${limit}`);
            dispatch(slice.actions.getWatchlistSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error.message || 'Error fetching watchlist'));
        }
    };
}

export function createWatchlistItem(data) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            const response = await axios.post('/api/rooms/watchlist', data);
            dispatch(slice.actions.createWatchlistSuccess(response.data));
            return { success: true };
        } catch (error) {
            dispatch(slice.actions.hasError(error.response?.data?.message || 'Error creating watchlist item'));
            return { success: false, error: error.response?.data?.message || 'Error creating watchlist item' };
        }
    };
}

export function updateWatchlistItem(id, data) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            await axios.put(`/api/rooms/watchlist/${id}`, data);
            
            // Fetch updated item data since API only returns success message
            const updatedData = { id, ...data };
            dispatch(slice.actions.updateWatchlistSuccess(updatedData));
            return { success: true };
        } catch (error) {
            dispatch(slice.actions.hasError(error.response?.data?.message || 'Error updating watchlist item'));
            return { success: false, error: error.response?.data?.message || 'Error updating watchlist item' };
        }
    };
}

export function deleteWatchlistItem(id) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            await axios.delete(`/api/rooms/watchlist/${id}`);
            dispatch(slice.actions.deleteWatchlistSuccess(id));
            return { success: true };
        } catch (error) {
            dispatch(slice.actions.hasError(error.response?.data?.message || 'Error deleting watchlist item'));
            return { success: false, error: error.response?.data?.message || 'Error deleting watchlist item' };
        }
    };
}

export function fetchStandings() {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            const response = await axios.get('/api/rooms/watchlist/standings');
            dispatch(slice.actions.getStandingsSuccess(response.data.standings));
        } catch (error) {
            dispatch(slice.actions.hasError(error.message || 'Error fetching standings'));
        }
    };
}